// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"ao-z","badgeLink":"bo-z","category":"co-z"};